'use client';
import useV2Vaults from '@/application/read/migrate/useV2Vaults';
import useLiquidityPools from '@/application/read/pools/useLiquidityPools';
import useVaults from '@/application/read/vaults/useVaults';
import { VAULT_FEE_TIER, addressEqual } from 'nftx.js';
import { useEffect, useState } from 'react';
import { V2Position } from '@/core/migrate';
import MigrateLiquidity from './MigrateLiquidity';
import Loading from './Loading';
import { useModalContext } from '@/presentation/context/modal';

const MigrateLiquidityContainer = ({ position }: { position: V2Position }) => {
  const { showMigrateSlpModal, showMigrateXSlpModal } = useModalContext();
  const { data: v2Vaults } = useV2Vaults();
  const { data: allVaults } = useVaults();

  const v2Vault =
    v2Vaults &&
    position &&
    v2Vaults.find((vault) => vault.vaultId === position.vaultId);
  const vaultIds = position.migrateOptions.map((option) => option.vaultId);
  const vaults = allVaults?.filter((v) => vaultIds.includes(v.vaultId));

  const { data: allLquidityPools } = useLiquidityPools(
    { exists: true, vaultIds },
    { enabled: !!vaultIds }
  );

  const [liquidityPoolId, setLiquidityPoolId] = useState('');
  const [isConcentratedRange, setIsConcentratedRange] = useState(false);

  const liquidityPools = allLquidityPools?.filter(
    (pool) => pool.feeTier === VAULT_FEE_TIER
  );

  useEffect(() => {
    if (vaults?.length && liquidityPools?.length && !liquidityPoolId) {
      const vault = vaults[0];
      const pool = liquidityPools.find((p) => p.vaultId === vault.vaultId);
      if (pool) {
        setLiquidityPoolId(pool.id);
      }
    }
  }, [liquidityPools, liquidityPoolId, vaults]);

  if (!position || !v2Vault || !vaults || !liquidityPools) {
    return <Loading />;
  }

  const handleSubmit = () => {
    const liquidityPool = liquidityPools.find((pool) =>
      addressEqual(pool.id, liquidityPoolId)
    );
    if (!liquidityPool) {
      throw new Error('Liquidity pool not found');
    }
    const vaultId = liquidityPool.vaultId;
    if (position.type === 'slp') {
      showMigrateSlpModal({
        positionId: position.id,
        v3VaultId: vaultId,
        fullRange: !isConcentratedRange,
      });
    } else {
      showMigrateXSlpModal({
        positionId: position.id,
        v3VaultId: vaultId,
        fullRange: !isConcentratedRange,
      });
    }
  };

  return (
    <MigrateLiquidity
      isConcentratedRange={isConcentratedRange}
      liquidityPoolId={liquidityPoolId}
      liquidityPools={liquidityPools}
      onIsConcentratedRangeChange={setIsConcentratedRange}
      onLiquidityPoolIdChange={setLiquidityPoolId}
      position={position}
      v2Vault={v2Vault}
      vaults={vaults}
      onSubmit={handleSubmit}
    />
  );
};

export default MigrateLiquidityContainer;
